import { OptimizationDto } from "#modules/optimizations/infra/computeOptimizations.api";

export const withPreservedCompatibleLines = (
  previous: OptimizationDto | undefined,
  updated: Omit<OptimizationDto, "compatibleLines">,
): OptimizationDto => {
  const previousLines = previous?.compatibleLines ?? [];

  return { ...updated, compatibleLines: previousLines };
};
